const totalCholesterin = {
  parameters: [
    {
      name: 'totalCholesterin',
      id: 'totalCholesterin',
      displayName: 'Total Cholesterin',
      validFrom: '2022/05/24 1:00',
      validThrough: null,
      interpretationsSupported: [
        'normal',
        'too-high',
        'fault',
      ],
      ranges: [{
        color: '#1f7359',
        description: 'totalCholesterin-normal',
        lowerLimit: 0,
        lowerLimitOperator: '>=',
        upperLimit: 5,
        upperLimitOperator: '<',
        unit: 'mmol/l',
        interpretation: 'normal',
        displayInterpretation: 'Normal',
        rangeInterpretation: '0 - 4.9',
      },
      {
        color: '#EF4036',
        description: 'totalCholesterin-too-high',
        lowerLimit: 5,
        lowerLimitOperator: '>=',
        upperLimit: 7,
        upperLimitOperator: '',
        unit: 'mmol/l',
        interpretation: 'too-high',
        displayInterpretation: 'Too high',
        rangeInterpretation: '>= 5',
      }],
    },
  ],
};

export default totalCholesterin;